export default {
    'FX-IR ID': 'withdraw.fxir.field.id',
    'FX-IR Account Name': 'withdraw.fxir.field.accName',
    'FX-IR Wallet Number': 'withdraw.fxir.field.walletNumber',
    'Transaction ID': 'deposit.fxir.field.transactionID',
    'Sender FX-IR ID': 'deposit.fxir.field.senderFxirID',
    'Bank Account Number': 'common.field.bankAccNum',
    'BankName': 'common.field.bankName',
  }
  